import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Protocol17025Chart_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Chart_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Protocol17025ChartService {

  constructor(private http:HttpClient) { }


  GetRecord(Token:String):Observable<Array<Protocol17025Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Protocol17025Chart?token="+Token).pipe(
      map(data=>{
        return data as Array<Protocol17025Chart_Interface>
      })
    )
  }

  AddEdit(model: Protocol17025Chart_Interface,Token:String):Observable<Protocol17025Chart_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id:model.id,
      title:model.title,
      code:model.code,
      parent:model.parent,
      chart_type:model.chart_type,
      token:Token
    }
    return this.http.post(environment.BaseUrl + "Daro/Protocol17025Chart/AddEdit",body,{headers}).pipe(
        map(data=>{
          return data as Protocol17025Chart_Interface
        })
    )

  }

  Delete(Id: number,
    Type: number,
    Token:String): Observable<Array<Protocol17025Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Protocol17025Chart/Delete?token=" + Token +
      "&id="+Id +
      "&Type=" + Type).pipe(
      map(data=>{
        return data as Array<Protocol17025Chart_Interface>
      })
    )
  }

  UpOrder(Id: number,Token:String): Observable<Array<Protocol17025Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Protocol17025Chart/UpOrder?token=" + Token + "&id="+Id).pipe(
      map(data=>{
        return data as Array<Protocol17025Chart_Interface>
      })
    )
  }

  DownOrder(Id: number,Token:String): Observable<Array<Protocol17025Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Protocol17025Chart/DownOrder?token=" + Token + "&id="+Id).pipe(
      map(data=>{
        return data as Array<Protocol17025Chart_Interface>
      })
    )
  }

  CutOrder(CutId: number,PastId: number,Up: boolean,Token:String): Observable<Array<Protocol17025Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Protocol17025Chart/CutOrder?token=" + Token
      + "&CutId=" + CutId
      + "&PastId=" + PastId
      + "&Up="+Up).pipe(
      map(data=>{
        return data as Array<Protocol17025Chart_Interface>
      })
    )
  }

  ChildOrder(CutId: number,PastId: number,Token:String): Observable<Array<Protocol17025Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Protocol17025Chart/ChildOrder?token=" + Token
      + "&CutId=" + CutId
      + "&PastId=" + PastId).pipe(
      map(data=>{
        return data as Array<Protocol17025Chart_Interface>
      })
    )
  }


}
